import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { Breadcrumbs, Typography } from "@mui/material";
import { ConvertPathText } from "./Utils/utils";

const NextBreadcrumbs = ({ title }) => {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbs] = useState(null);

  useEffect(() => {
    if (router) {
      const linkPath = router.asPath.split("/");
      linkPath.shift();
      const pathArray = linkPath.map((path, i) => {
        return {
          breadcrumb: path,
          href: "/" + linkPath.slice(0, i + 1).join("/"),
        };
      });
      setBreadcrumbs(pathArray);
    }
  }, [router]);

  if (!breadcrumbs) {
    return null;
  }
  const breadcrumbsLength = breadcrumbs.length;
  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link underline="hover" color="inherit" href="/">
        Home
      </Link>
      {breadcrumbs.map((breadcrumb, i) => {
        // const text = convertBreadcrumb(breadcrumb.breadcrumb);
        const text = ConvertPathText(breadcrumb.breadcrumb);
        if (breadcrumbsLength - 1 == i) {
          return (
            <Typography key={"Breadcrumb_" + i} color="text.primary">
              {title ? title : text}
            </Typography>
          );
        }
        return (
          <Link
            key={"Breadcrumb_" + i}
            underline="hover"
            color="inherit"
            href={breadcrumb.href}
          >
            {text}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default NextBreadcrumbs;
